import(/* webpackMode: "eager", webpackExports: ["NavigationProgressBar"] */ "/app/fuse_common/components/ui/navigation-progress-bar.tsx");
;
import(/* webpackMode: "eager" */ "/app/fuse_common/styles/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["RootContextProvider"] */ "/app/fuse_customer_app/src/app/context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeApplier"] */ "/app/fuse_customer_app/src/components/app-theme.tsx");
;
import(/* webpackMode: "eager" */ "/app/fuse_customer_app/src/utils/throttle-replace-state.ts");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.1.6_@babel+core@7.26.7_@opentelemetry+api@1.9.0_@playwright+test@1.50.0_babel-plugin-_beyxwy5v5r37cieeuhw72ndjia/node_modules/next/font/local/target.css?{\"path\":\"../fuse_common/utils/ui/fonts.ts\",\"import\":\"\",\"arguments\":[{\"src\":\"../../assets/TT_Rounds_Neue_Variable.ttf\"}],\"variableName\":\"ttRoundsNeueVariable\"}");
